import { Routes, Route } from "react-router-dom";
import { styles, css } from "./styles";
import { ShopProvider, useShop } from "./context/ShopContext";
import { ToastProvider } from "./context/ToastContext";
import { Header } from "./components/Header";
import { ErrorNote } from "./components/common";
import { Customer } from "./components/customer/Customer";
import { Admin } from "./components/admin/Admin";

function Shell() {
  const { loading, error } = useShop();
  return (
    <div style={styles.root}>
      <style>{css}</style>
      <Header />
      <main style={styles.main}>
        {error && <ErrorNote>{error}</ErrorNote>}
        {loading ? (
          <div style={styles.spinnerWrap} role="status" aria-live="polite">
            Loading the shop&hellip;
          </div>
        ) : (
          <Routes>
            <Route path="/" element={<Customer />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        )}
      </main>
    </div>
  );
}

export function App() {
  return (
    <ToastProvider>
      <ShopProvider>
        <Shell />
      </ShopProvider>
    </ToastProvider>
  );
}
